(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ln-entry-offers"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', event => {
    const link=event.target.closest('a[data-ln-offer]');
    if (!link) return;
    if (link.hasAttribute('data-ln-open-pack')) {
      const details=document.querySelector('#ln-armar-pack details');
      if (details) details.open=true;
    }
    try { window.Shopify?.analytics?.publish('ln:offer_click',{offer:link.dataset.lnOffer}); } catch (_) {}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ln-launch-campaign"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ln-pack-request')) {
    customElements.define('ln-pack-request',class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort(); this.abort=new AbortController();
        const options={signal:this.abort.signal};
        this.inputs=Array.from(this.querySelectorAll('input[data-cut]'));
        this.link=this.querySelector('[data-send]');
        this.addEventListener('click',event=>{
          const step=event.target.closest('[data-step]');
          if(step) {
            const input=step.parentElement.querySelector('input');
            const next=Number(input.value)+Number(step.dataset.step);
            if(Number.isInteger(next)&&next>=0&&next<=10) input.value=String(next);
            this.update();
          }
          if(event.target.closest('[data-send]')) {
            this.update();
            if(this.link.getAttribute('aria-disabled')==='true') {event.preventDefault();return;}
            try{window.Shopify?.analytics?.publish('ln:pack_inquiry',{offer:'ten-bags',bags:10,city:this.querySelector('[data-city]').value,cuts:this.inputs.map(input=>({cut:input.dataset.cut,quantity:Number(input.value)}))});}catch(_){}
          }
        },options);
        this.addEventListener('input',()=>this.update(),options);
        this.addEventListener('change',()=>this.update(),options);
        this.update();
      }
      update() {
        let valid=true;
        const total=this.inputs.reduce((sum,input)=>{
          const number=Number(input.value);
          const ok=input.value!==''&&Number.isInteger(number)&&number>=0&&number<=10;
          input.setAttribute('aria-invalid',String(!ok));valid=valid&&ok;
          return sum+(ok?number:0);
        },0);
        this.querySelector('[data-count-label]').textContent=this.dataset.countText.replace('[count]',String(total));
        this.querySelector('progress').value=Math.min(total,10);
        const city=this.querySelector('[data-city]').value;
        const rates={Rosario:0,Funes:10000,'Roldán':12000};
        const hasCity=Object.hasOwn(rates,city);
        const ready=valid&&total===10&&hasCity;
        this.dataset.selectionValid=String(valid&&total===10);
        const money=new Intl.NumberFormat('es-AR',{style:'currency',currency:'ARS',maximumFractionDigits:0});
        const shipping=hasCity?(city==='Rosario'?this.dataset.rosario:`${city}: envío ${money.format(rates[city])}. Total del pack con envío: ${money.format(110000+rates[city])}. Reparto: martes y jueves.`):'';
        this.querySelector('[data-delivery]').textContent=shipping;
        this.querySelector('[data-status]').textContent=valid&&total===10?(hasCity?this.dataset.complete:this.dataset.selectCity):this.dataset.incomplete;
        this.link.setAttribute('aria-disabled',String(!ready));
        if(!ready){this.link.removeAttribute('href');this.link.tabIndex=-1;return;}
        const lines=[this.dataset.message,...this.inputs.filter(input=>Number(input.value)>0).map(input=>`${input.dataset.cut}: ${input.value} bolsa(s) de 4 kg`),'10 bolsas / 40 kg. Productos: $110.000 ARS.',shipping,this.dataset.followup];
        try {
          const url=new URL(this.dataset.contact);
          if(url.protocol!=='https:'||url.hostname!=='wa.me') throw new Error('Invalid contact URL');
          url.searchParams.set('text',lines.join('\n'));
          this.link.href=url.href;this.link.tabIndex=0;
        } catch(_) {this.link.removeAttribute('href');this.link.setAttribute('aria-disabled','true');this.link.tabIndex=-1;}
      }
      disconnectedCallback(){this.abort?.abort();}
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ln-mobile-check"]) return;
  try {
    
  if (!customElements.get('ln-mobile-check')) {
    customElements.define('ln-mobile-check', class extends HTMLElement {
      connectedCallback() {
        this.querySelector('select').addEventListener('change', (event) => {
          const width = Number(event.target.value);
          this.style.setProperty('--ln-check-width', `${width}px`);
          this.style.setProperty('--ln-check-height', `${width * 2}px`);
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ln-salt-bundle"]) return;
  try {
    
  if (!customElements.get('ln-salt-bundle')) {
    customElements.define('ln-salt-bundle', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.form = this.querySelector('form');
        this.selects = [...this.querySelectorAll('select')];
        this.button = this.querySelector('button');
        this.error = this.querySelector('[data-error]');
        this.form.addEventListener('change', () => this.update());
        this.form.addEventListener('submit', event => this.submit(event));
        this.update();
      }
      selection() {
        const items = new Map();
        const prices = [];
        for (const select of this.selects) {
          if (!select.value || select.disabled) return null;
          const option = select.selectedOptions[0];
          if (option.disabled) return null;
          const item = items.get(select.value) || { id: Number(select.value), quantity: 0, limit: Number(option.dataset.limit) };
          item.quantity++;
          items.set(select.value, item);
          prices.push(Number(option.dataset.price));
        }
        return { items: [...items.values()], total: prices.sort((a, b) => a - b).slice(1).reduce((sum, price) => sum + price, 0) };
      }
      message(selector) { return this.querySelector(selector).content.textContent.trim(); }
      showError(message) { this.error.textContent = message; this.error.hidden = !message; }
      update() {
        const selection = this.selection();
        const overStock = selection?.items.some(item => item.limit >= 0 && item.quantity > item.limit);
        this.button.disabled = this.busy || !selection || overStock;
        this.querySelector('[data-total]').textContent = selection ? new Intl.NumberFormat(this.dataset.locale, { style: 'currency', currency: this.dataset.currency }).format(selection.total / 100) : '—';
        if (!this.busy) this.showError(overStock ? this.message('[data-stock-message]') : '');
      }
      async submit(event) {
        event.preventDefault();
        if (this.busy || !this.form.reportValidity()) return;
        const selection = this.selection();
        if (!selection || selection.items.some(item => item.limit >= 0 && item.quantity > item.limit)) return;
        this.busy = true;
        this.button.disabled = true;
        this.form.setAttribute('aria-busy', 'true');
        this.showError('');
        let attemptedAdd = false;
        try {
          const cartResponse = await fetch(this.dataset.cartUrl + '.js', { headers: { Accept: 'application/json' } });
          if (!cartResponse.ok) throw new Error('cart');
          const cart = await cartResponse.json();
          const insufficient = selection.items.some(item => {
            const existing = cart.items.filter(line => line.variant_id === item.id).reduce((sum, line) => sum + line.quantity, 0);
            return item.limit >= 0 && existing + item.quantity > item.limit;
          });
          if (insufficient) { this.showError(this.message('[data-stock-message]')); return; }
          attemptedAdd = true;
          const response = await fetch(this.dataset.addUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: selection.items.map(({ id, quantity }) => ({ id, quantity })) }) });
          if (!response.ok) throw new Error('add');
          const result = await response.json();
          if (result.status) throw new Error('add');
          window.location.assign(this.dataset.cartUrl);
        } catch {
          this.showError(this.message('[data-cart-message]'));
        } finally {
          this.form.removeAttribute('aria-busy');
          if (!attemptedAdd) { this.busy = false; this.button.disabled = false; }
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
